import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  };

  // Called when user picks a suggestion from the Places search box
  handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.props.selectGoogleAddressPin(address, latLng.lat, latLng.lng);
      })
      .catch((error) => console.error("Error", error));
  };

  // Called when the draggable marker is dropped at a new position
  onMarkerDragEnd = (props, marker) => {
    const lat = marker.getPosition().lat();
    const lng = marker.getPosition().lng();

    // Update parent state with new lat/lng
    this.props.onMarkerDragEnd(lat, lng);

    // Reverse-geocode to get the address at the dragged position
    const geocoder = new this.props.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        this.props.selectGoogleAddressPin(address, lat, lng);
      }
    });
  };

  render() {
    const searchOptions = {
      componentRestrictions: { country: ["ind"] },
    };

    const lat =
      this.props.latitude === "" ||
      this.props.latitude === undefined ||
      this.props.latitude == 0
        ? 8.555164446
        : parseFloat(this.props.latitude);

    const lng =
      this.props.longitude === "" ||
      this.props.longitude === undefined ||
      this.props.longitude == 0
        ? 76.875496498
        : parseFloat(this.props.longitude);

    return (
      <div className="gmap-div">
        {/* Places search box */}
        <PlacesAutocomplete
          value={this.props.googleAddressPin || ""}
          onChange={this.props.setGoogleAddressPin}
          onSelect={this.handleSelect}
          searchOptions={searchOptions}
        >
          {({  suggestions, getSuggestionItemProps, loading }) => (
            <div style={{ position: "relative", marginBottom: "8px" }}>
              {(loading || suggestions.length > 0) && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    zIndex: 1000,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {loading && (
                    <div style={{ padding: "8px 12px", color: "#888" }}>
                      Loading...
                    </div>
                  )}
                  {suggestions.map((suggestion) => {
                    const style = {
                      padding: "8px 12px",
                      cursor: "pointer",
                      background: suggestion.active ? "#f0f4ff" : "#fff",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "13px",
                    };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, { style })}
                        key={suggestion.placeId}
                      >
                        📍 {suggestion.description}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </PlacesAutocomplete>

        {/* Map with draggable marker */}
        <div id="googleMap">
          <div className="adrsmap-hspadmin">
            <Map
              google={this.props.google}
              initialCenter={{ lat, lng }}
              center={{ lat, lng }}
              zoom={15}
            >
              <Marker
                name={"Clinic location"}
                position={{ lat, lng }}
                draggable={true}
                onDragend={this.onMarkerDragEnd}
                title="Drag to set exact location"
              />
            </Map>
          </div>
        </div>

        <p style={{ fontSize: "11px", color: "#888", marginTop: "6px" }}>
          📌 Drag the pin to set the exact clinic location
        </p>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_googleMapKey,
})(MapContainer);
